import bckImg from '../../assets/images/landing_black.jpg' // Hot Pink

const styles = theme => ({
  background: {
    backgroundImage: `url(${bckImg})`,
    height: '100vh'
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: '100%'
  },
  logo: {
    width: '300px'
  },
  text: {
    color: '#fff',
    textAlign: 'center',
    margin: '0px 40px',
    maxWidth: '400px'
  },
  button: {
    background: 'rgba(226,66,90,1)',
    fontWeight: 'bold'
  },
  copyRight: {
    margin: '0px auto',
    position: 'relative',
    top: '20px',
    bottom: 0,
    marginBottom: '2px'
  },
  copyRightText: {
    color: theme.palette.primary.dark,
    width: '100%',
    fontSize: 11
  }
})

export default styles
